module.exports = __webpack_public_path__ + "img/full-07.0f1b05fd.png";